import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastService } from './services/toast.service';
import { ToastComponent } from "./common/components/toast/toast.component";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('kotlin-web');
  private toastService = inject(ToastService);

  public addTestToast() {
    this.toastService.success({ title: 'Test toast', duration: 60000 });
  }
}
